module.exports = __webpack_public_path__ + "static/img/image-benefit.efc3268.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/enroll/after-bootcamp/clix/image-benefit/image-benefit.png
// module id = RqxD
// module chunks = 35